import { render, staticRenderFns } from "./applyMy2.vue?vue&type=template&id=f1a5e5a2&scoped=true&"
import script from "./applyMy2.vue?vue&type=script&lang=js&"
export * from "./applyMy2.vue?vue&type=script&lang=js&"
import style0 from "./applyMy2.vue?vue&type=style&index=0&id=f1a5e5a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a5e5a2",
  null
  
)

export default component.exports